import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap, catchError, finalize } from 'rxjs/operators';
import { InvestigationTypeState } from '../../states/investigation-type.state';
import { ChecklistListState } from '../../states/checklist-list.state';
import { SaveChecklistResult } from './save-checklist.result';
import { ChecklistRepository, SaveChecklistParams } from '../../../infrastructure/repositories/checklist.repository';

@Injectable({ providedIn: 'root' })
export class SaveChecklistUseCase {
  private readonly _repository = inject(ChecklistRepository);
  private readonly _state = inject(InvestigationTypeState);
  private readonly _checklistListState = inject(ChecklistListState);

  public execute(investigationTypeId: string, params: SaveChecklistParams): Observable<SaveChecklistResult> {
    this._state.setSavingChecklist(true);
    this._state.clearErrorChecklist();

    return this._repository.saveChecklist(investigationTypeId, params).pipe(
      tap(() => {
        this._checklistListState.clear();
      }),
      map((entity) => ({
        checklist: {
          id: entity.id,
          displayOnInvestigations: entity.displayOnInvestigations,
          steps: entity.steps,
        },
      })),
      catchError((error) => {
        const errorMessage = error?.error?.message || error?.message || 'Failed to save checklist';
        this._state.setErrorChecklist(errorMessage);
        throw error;
      }),
      finalize(() => {
        this._state.setSavingChecklist(false);
      }),
    );
  }
}
